import React from "react"
import { BannerDetail } from "./BannerDetail"
import { Grid, withStyles } from "@material-ui/core"
import CourseDetailTabs from "./CourseDetailTabs"
import { Reviews } from "./Reviews"
import CoursePlayer from "../CoursePlayer"

const CourseDetail = ({
  classes,
  course,
  onBuyCourseClick,
  render,
}) => (
  <>
    <Grid container className={classes.bannerDetail}>
      <Grid item xs={12}>
        <BannerDetail
          title={course.name}
          smallDesc={course.details.smallDesc}
          price={course.details.price}
          discountedPrice={course.details.discountedPrice}
          preOrderText={course.details.preOrderText || ""}
          classes={classes}
          buyLabel={course.buyLabel}
          watchLabel={course.watchLabel}
          watchUrl={course.watchUrl}
          onBuyCourseClick={onBuyCourseClick}
        />
      </Grid>
    </Grid>
    <Grid item xs={12}>
      <CoursePlayer
        syllabus={course.details.syllabus}
        price={course.details.price}
        onBuyCourseClick={onBuyCourseClick}
      />
    </Grid>

    {render()}

    <Grid container justify={"center"} className={classes.tabs}>
      <Grid item xs={12}>
        <CourseDetailTabs
          courseDuration={course.duration}
          level={course.level}
          details={course.details}
          onEnrollClick={onBuyCourseClick}
          enrollUrl={course.buyUrl}
        />
      </Grid>
    </Grid>

    {course.reviews.length > 0 && <Reviews reviews={course.reviews} />}
  </>
)

const styles = theme => ({
  bannerDetail: {
    overflowX: "hidden",
    backgroundColor: theme.palette.secondary.surface,
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(7),
    paddingBottom: theme.spacing(5),
  },
  buyNowButtonItem: {
    paddingTop: theme.spacing(1),
  },

  preOrderText: {
    paddingTop: theme.spacing(2),
  },
  watchTrailerButtonItem: {
    paddingTop: theme.spacing(2),
  },
  videoPlayer: {
    height: 400,
    width: 600,
    [theme.breakpoints.down("md")]: {
      height: 200,
      width: 300,

    },
  },
  smallDesc: {
    textAlign: "center",
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  tabs: {
    marginBottom: theme.spacing(10),
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
})

export default withStyles(styles)(CourseDetail)
